import { Button, Card, Icon, Typography } from '@design-system/index';
import './EditionPage.scss';
import { useBookingEditionPageVM } from './useEditionPageVM';
import { AppartementsLine, PrinterLine } from '@assets/images/icons';

import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import frLocale from '@fullcalendar/core/locales/fr';
import { EventClickArg } from '@fullcalendar/core';
import { formatDate } from '@utils/dates';
import { useNavigate } from 'react-router-dom';

export default function BookingEditionPage() {
    const { handleDatesSet, editionData, isLoading, MySwal, openPrintBooking } = useBookingEditionPageVM();
    const navigate = useNavigate();

    const handleEventClick = (info: EventClickArg) => {
        const event = info.event;
        const resource = event.getResources?.()[0] || event._def.resourceIds?.[0] || '';

        const { bookingId, apartmentId } = (event.extendedProps ?? {}) as { bookingId?: number; apartmentId?: number };
        const canOpenBooking = Boolean(bookingId && apartmentId);

        MySwal.fire({
            title: "Détails de la réservation",
            showCancelButton: true,
            cancelButtonColor: '#9E9E9E',
            cancelButtonText: 'Fermer',
            showConfirmButton: canOpenBooking,
            confirmButtonColor: '#01539D',
            confirmButtonText: 'Ouvrir la réservation',
            heightAuto: false,
            html: (
                <div>
                    <div className="label-value" style={{ marginBottom: '10px' }}>
                        <Typography intrinsic="p" variant="p2" color="grey1">Adhérent</Typography>
                        <Typography intrinsic="h3" variant="secondary" color="secondary">{event.title}</Typography>
                    </div>
                    <div className="label-value" style={{ marginBottom: '10px' }}>
                        <Typography intrinsic="p" variant="p2" color="grey1">Logement</Typography>
                        <Typography intrinsic="h3" variant="secondary" color="secondary">{resource.title}</Typography>
                    </div>
                    {event.start && (
                        <div className="label-value" style={{ marginBottom: '10px' }}>
                            <Typography intrinsic="p" variant="p2" color="grey1">Début</Typography>
                            <Typography intrinsic="h3" variant="secondary" color="secondary">{formatDate(event.start.toISOString())}</Typography>
                        </div>
                    )}
                    {event.end && (
                        <div className="label-value">
                            <Typography intrinsic="p" variant="p2" color="grey1">Fin</Typography>
                            <Typography intrinsic="h3" variant="secondary" color="secondary">{formatDate(event.end.toISOString())}</Typography>
                        </div>
                    )}
                </div>
            ),
            focusConfirm: false,
        }).then((result) => {
            if (result.isConfirmed && canOpenBooking) {
                navigate(`/members-management/apartments/${apartmentId}/bookings/${bookingId}/edit`, {
                    state: { backTo: '/members-management/apartments/edition' }
                });
            }
        });
    };

    return (        
        <div className="bookings-container">
            <Card 
            headerType='full' 
            isLoading={isLoading} 
            showBack 
            backTo="/members-management" 
            headerTitle="Planning logements" 
            topActions={<Button variant="secondary" onClick={() => navigate('/members-management/bookings')}>Liste des réservations</Button>}
            headerIcon={<Icon icon={<AppartementsLine />} size={20} color="green-water" />}
            headerStaticAction={<Button 
                variant="icon"
                color="primary"
                size="small"
                hoverIcon={<Icon icon={<PrinterLine />} size={20} color="primary" />}
                icon={<Icon icon={<PrinterLine />} size={20} color="grey1" />}
                onClick={openPrintBooking}
            />}
            >
                <FullCalendar
                    schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
                    plugins={[resourceTimelinePlugin]}
                    initialView="resourceTimelineMonth"
                    locale={frLocale}
                    resourceAreaHeaderContent="Logements"
                    datesSet={handleDatesSet}
                    eventClick={handleEventClick}
                    headerToolbar={{
                        left: 'prev,next',
                        center: 'title',
                        right: 'resourceTimelineMonth,resourceTimeline3Months'//,resourceTimeline6Months'
                    }}
                    views={{
                        resourceTimelineMonth: {
                            type: 'resourceTimeline',
                            duration: { months: 1 },
                            buttonText: '1 mois'
                        },
                        resourceTimeline3Months: {
                            type: 'resourceTimeline',
                            duration: { months: 3 },
                            buttonText: '3 mois'
                        }/*,
                        resourceTimeline6Months: {
                            type: 'resourceTimeline',
                            duration: { months: 6 },
                            buttonText: '6 mois'
                        }*/
                    }}
                    resources={ editionData?.resources }
                    events={ editionData?.events }
                    height={500}
                    slotMinWidth={100}
                    nowIndicator={true}
                    editable={false}
                    selectable={false}
                    eventOverlap={false}
                    slotMinTime="00:00:00"
                    slotMaxTime="24:00:00"
                    />
            </Card>
        </div>
    );
};
